/**
 * @description Scrims component should be displayed only in SMALL viewport size
 * This is for indicating the user that in LOB navigation carousel there are more elements
 * in the right or left size that can be seen scrolling horizontally
 */
import * as React from "react";

import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { UitkScrim, UitkScrimType } from "uitk-react-scrim";
import { scrimValues, LobNavigationScrimsProps } from "./typings";

const valuesToDisplayLeftScrim = [scrimValues.LEFT, scrimValues.BOTH];
const valusToDisplayRightScrim = [scrimValues.RIGHT, scrimValues.BOTH];

export const LobNavigationScrims = ({ scrimsToDisplay }: LobNavigationScrimsProps) => {
  if (scrimsToDisplay === scrimValues.EMPTY) {
    return null;
  }

  return (
    <Viewport>
      <ViewSmall>
        <>
          {valuesToDisplayLeftScrim.includes(scrimsToDisplay) && (
            <UitkScrim type={UitkScrimType.LEFT} className="lobNavigationScrim" />
          )}

          {valusToDisplayRightScrim.includes(scrimsToDisplay) && (
            <UitkScrim type={UitkScrimType.RIGHT} className="lobNavigationScrim lobNavigationScrimRight" />
          )}
        </>
      </ViewSmall>
      <ViewMedium />
    </Viewport>
  );
};
